import { render, staticRenderFns } from "./bindThreeLogin.vue?vue&type=template&id=5c3d3ec6&scoped=true&"
import script from "./bindThreeLogin.vue?vue&type=script&lang=js&"
export * from "./bindThreeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d3ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3d3ec6')) {
      api.createRecord('5c3d3ec6', component.options)
    } else {
      api.reload('5c3d3ec6', component.options)
    }
    module.hot.accept("./bindThreeLogin.vue?vue&type=template&id=5c3d3ec6&scoped=true&", function () {
      api.rerender('5c3d3ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/bindThreeLogin.vue"
export default component.exports